import axios from 'axios'
import store from './store/index'
import { SKIPPED_MESSAGES_CODES } from '@/constants'

let axiosSetupInterceptors = () => {
	const BASE_URL = window.location.origin
	const isProductionMode = process.env.NODE_ENV === 'production'

	axios.defaults.baseURL = isProductionMode
		? `${BASE_URL}/api/`
		: 'https://online-menu-test.smarttab.com/api/'
	// 'https://tickets-test.smarttab.com/api/'
	// 'http://localhost/api'
	// 'https://tickets-test-2.smarttab.com/api/'
	// 'https://online-menu-test-2.smarttab.com/api/'

	axios.interceptors.request.use(
		async config => {
			config.headers['Content-Type'] = 'application/json'
			config.headers['Accept'] = 'application/json'

			if (isProductionMode) {
				config.headers['Cache-Control'] = 'no-cache'
				config.headers['Pragma'] = 'no-cache'
			}

			store.commit('user/updateToken')
			const token = store.getters['user/token']
			if (token) {
				config.headers['Authorization'] = `${token}`
			}

			return config
		},
		async err => {
			throw err
		}
	)

	axios.interceptors.response.use(
		response => {
			if (response && response.data && response.data.error) {
				throw response.data
			}

			return response
		},
		error => {
			const { response } = error

			if (response?.status === 500 && !response?.data?.message) {
				store.commit('ui/addMainError', 'SERVER ERROR')
			}

			throw error
		}
	)
}

class AxiosWrapper {
	constructor() {
		axiosSetupInterceptors()
		this.axios = axios
	}

	errorHandler(url, err, customConfig) {
		if (axios.isCancel(err)) {
			return []
		}

		const { skipError } = customConfig || {}
		const { data } = err.response || {}
		const { error } = data || {}

		const validationCode = error?.validationCode
		const message = error?.validationMessage

		if (
			!skipError &&
			!(validationCode && SKIPPED_MESSAGES_CODES.includes(validationCode)) &&
			message
		) {
			store.commit('ui/addMainError', message)
		}
	}

	async sendRequest({ method, url, data, params, axiosConfig, customConfig }) {
		const requestMethod = reqData => {
			if (method === 'post') {
				return this.axios.post(url, reqData, axiosConfig)
			} else if (method === 'get') {
				return this.axios.get(url, params)
			} else if (method === 'patch') {
				return this.axios.patch(url, reqData, axiosConfig)
			} else if (method === 'put') {
				return this.axios.put(url, reqData, axiosConfig)
			} else if (method === 'delete') {
				return this.axios.delete(url, reqData, axiosConfig)
			}
		}

		try {
			return await requestMethod(data)
		} catch (err) {
			const { status } = err.response || {}
			if (status === 401) {
				try {
					await store.dispatch('user/logout')
					window.location.reload()
					// const venueId = store.getters['venue/venueId']
					// await store.dispatch('user/login')
					// await store.dispatch('user/getUser')
					// await store.dispatch('cart/getCart', { venueId })
					// const cartId = store.state.cart.id
					// if (data.cartId) {
					// 	data.cartId = cartId
					// }
					// return await requestMethod(data)
				} catch (e) {
					this.errorHandler(url, err, customConfig)
					throw err
				}
			}
			this.errorHandler(url, err, customConfig)
			throw err
		}
	}

	async post(url, data, axiosConfig, customConfig) {
		return this.sendRequest({
			method: 'post',
			url,
			data,
			axiosConfig,
			customConfig
		})
	}

	async get(url, params, customConfig) {
		return this.sendRequest({
			method: 'get',
			url,
			params,
			customConfig
		})
	}

	async patch(url, data, axiosConfig, customConfig) {
		return this.sendRequest({
			method: 'patch',
			url,
			data,
			axiosConfig,
			customConfig
		})
	}

	async put(url, data, axiosConfig, customConfig) {
		return this.sendRequest({
			method: 'put',
			url,
			data,
			axiosConfig,
			customConfig
		})
	}

	async delete(url, data, axiosConfig, customConfig) {
		return this.sendRequest({
			method: 'delete',
			url,
			data,
			axiosConfig,
			customConfig
		})
	}
}

const wrapper = new AxiosWrapper()

export default wrapper
